import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import { IAvailabilitySchedule } from "intake_shared/src/types";
import * as React from "react";

interface BigCalendarProps {
    events: IAvailabilitySchedule[];
    components?: any;
    setShowPopup?: (value: React.SetStateAction<boolean>) => void;
    setEventDetails?: (value: React.SetStateAction<IAvailabilitySchedule>) => void;
    eventStyleGetter: any;
    showToolbar?: boolean;
    currentView?: any;
    currentDate?: Date;
    onViewChange?: (view: any) => void;
    onDateChange?: (date: Date) => void;
    minTime?: Date;
    maxTime?: Date;
    scrollToTime?: Date;
}

export default function BigCalendar({
    events,
    components,
    setShowPopup,
    setEventDetails,
    eventStyleGetter,
    showToolbar,
    currentView = Views.WEEK,
    currentDate = new Date(),
    onViewChange,
    onDateChange,
    minTime,
    maxTime,
    scrollToTime,
}: BigCalendarProps) {
    const localizer = momentLocalizer(moment);

    const defaultScrollToTime =
        scrollToTime || moment(currentDate).startOf("day").hour(7).toDate();

    return (
        <div>
            <Calendar
                localizer={localizer}
                events={events}
                eventPropGetter={(event: IAvailabilitySchedule) =>
                    eventStyleGetter(event)
                }
                startAccessor="start"
                endAccessor="end"
                view={currentView}
                date={currentDate}
                onView={(newView) => onViewChange && onViewChange(newView)}
                onNavigate={(newDate) => {
                    onDateChange && onDateChange(newDate);
                    localStorage.setItem(
                        "clinicianAvailability_currentDate",
                        newDate.toISOString()
                    );
                }}
                onSelectEvent={(event: IAvailabilitySchedule) => {
                    setShowPopup && setShowPopup(true);
                    setEventDetails && setEventDetails(event);
                }}
                views={["week", "day", "month"]}
                style={{ height: "calc(100vh - 80px)" }}
                components={components}
                toolbar={false}
                scrollToTime={defaultScrollToTime}
            />
        </div>
    );
}
